import { formatUnitTotals } from "../lib/confirmedProduction";

const Kpi = ({ label, value, hint, accent, testId }) => (
  <div className="min-w-[140px]">
    <p className="text-[10px] font-heading font-bold uppercase tracking-wide text-[#667085]">{label}</p>
    <p className={`font-heading text-lg font-bold tabular-nums ${accent ? "text-[#0E7C86]" : "text-[#101828]"}`} data-testid={testId}>{value}</p>
    {hint && <p className="text-[10px] text-[#98A2B3] mt-0.5">{hint}</p>}
  </div>
);

// Oct 22 2026, user's explicit ask: finished production and operation
// confirmations are two different numbers and must never be one KPI, and no
// total ever mixes units of measure.
export const ConfirmedProductionKpis = ({ kpis, scope }) => (
  <div className="border border-[#D0D5DD] rounded-sm bg-white px-4 py-3 flex flex-wrap items-start gap-x-8 gap-y-3" data-testid="confirmed-report-totals">
    <Kpi
      label="Finished Production Qty"
      value={formatUnitTotals(kpis.finished)}
      hint={`final reporting point (END) only · ${kpis.finishedTransactions} confirmation${kpis.finishedTransactions === 1 ? "" : "s"}`}
      accent
      testId="kpi-finished-qty"
    />
    <Kpi
      label="Operation Confirmation Qty"
      value={formatUnitTotals(kpis.operations)}
      hint="every operation, work in progress included"
      testId="kpi-operation-qty"
    />
    <Kpi label="Confirmation Transactions" value={kpis.transactions.toLocaleString("en-IN")} testId="kpi-transactions" />
    <Kpi label="Total Scrap" value={formatUnitTotals(kpis.scrap)} testId="kpi-scrap" />
    <Kpi label="Total By-product Qty" value={formatUnitTotals(kpis.byproduct)} testId="kpi-byproduct" />
    <p className="text-[11px] text-[#667085] ml-auto max-w-[300px] text-right" data-testid="confirmed-report-totals-scope">{scope}</p>
  </div>
);
